export default __webpack_public_path__ + "static/media/toggle-profile-b.465f01c4.svg";